<template>
	<div class="tabWrapperSettings tabHolidays">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="itemsHolidays"
				@updateClickButton="onClickButton($event, flag)"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateCreate="onCreate"
				text-create="Add new holiday"
				page-title="Holidays"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-holidays
				v-if="isViewHolidays"
				:dialogFlag="dialogFlag"
				@updateSave="onSaveViewHolidays"
				@updateClose="onCloseDialog('isViewHolidays')"
				@updateList="onUpdateList('holidays')"
		></view-holidays>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabHolidaysTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewHolidays from "@/components/Settings/UserAccountSettings/ViewHolidays/ViewHolidays.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { PERMISSIONS, TAB } from "@/constants/constants";

import { mapActions, mapGetters } from "vuex";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabHolidays",
	components: {
		DialogRemove,
		ViewHolidays,
		MainTable
	},
	computed: {
		...mapGetters([
			'settingsHolidays',
			'itemsHolidays',
			'filtersHolidays',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabHolidaysTable;
		},
	},

	data: () => ({
		flag: TAB.HOLIDAYS,

		isViewHolidays: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountHolidaysList',
			'getAccountHolidaysEdit',
			'deleteAccountHolidays',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_HOLIDAYS, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},
		async onUpdateList(key) {
			if (key === 'holidays') {
				await this.getAccountHolidaysList();
			}
		},

		onClickButton({ key, item }, nameComponent) {
			this.dialogFlag = 'edit';

			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === 'tabHolidays' && key === 'edit1') {
				this.accountHolidaysEdit();
			}
			if (nameComponent === 'tabHolidays' && key === 'delete1') {
				const title = TITLE.REMOVE_HOLIDAYS;
				const text = TEXT.REMOVE_HOLIDAYS;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'tabHolidays') {
				const { id } = this.activeItem;
				await this.deleteAccountHolidays(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountHolidaysEdit() {
			const { id } = this.activeItem;
			await this.getAccountHolidaysEdit(id);
			this.isViewHolidays = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewHolidays = true;
		},
		onSaveViewHolidays(args) {
			console.info('%c [ onSaveViewHolidays args  ] ', 'color:#bada55', typeof args, args );
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountHolidaysList();
	}
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
</style>

